import * as Flags from "country-flag-icons/react/3x2";

export type CountryFlagProps = {
  iso2: string;
  className?: string;
};

export function CountryFlag({ iso2, className }: CountryFlagProps) {
  const Flag = Flags[iso2 as keyof typeof Flags];

  if (!Flag) {
    return null;
  }

  return <Flag className={className} />;
}
